<template>
  <div>
    <div class="banner">
      <hr />
      <video muted playsinline ref="vidScanCode" width="100%"></video>
      <hr />
    </div>
    <div @click="$emit('onScannedCode', 'fake')">{{message}}</div>
    <font-awesome-icon icon="arrow-circle-left" class="fa-2x"
        @click="$emit('onScannedCode', 'cancelled')" />
  </div>
</template>
<script>
import QrScanner from 'qr-scanner'; // if installed via package and bundling with webpack or rollup

export default {
  props: {
    message: String,
  },
  data() {
    return {
      qrScanner: null,
    };
  },
  mounted() {
    this.qrScanner = new QrScanner(this.$refs.vidScanCode,
      (result) => {
        // console.log('decoded qr code:', result);
        this.$emit('onScannedCode', result);
      },
      200);
    this.qrScanner.start()
      // eslint-disable-next-line
      .catch(console.error);
  },
  beforeDestroy() {
    this.qrScanner.destroy();
  },
};
</script>
